(function () {
  'use strict';

  angular.module('lif.services').factory('userService', userService);
  userService.$inject = ['bootstrappedNavigationModel'];

  function userService(bootstrappedNavigationModel) {
    var _userService = {};

    _userService.getLoggedInUser = function () {
      return bootstrappedNavigationModel.user;
    };

    return _userService;
  }
})();